import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.weak-map";
import "core-js/modules/web.dom-collections.iterator";
export var watchers = new Map();
export var watchedElements = new WeakMap();

function domToObj(domEl) {
  var keepAttrs = ["id", "tagName", "className"];
  var obj = {};

  for (var _i = 0, _keepAttrs = keepAttrs; _i < _keepAttrs.length; _i++) {
    var attr = _keepAttrs[_i];
    obj[attr] = domEl[attr];
  }

  return obj;
}

function replacer(key, value) {
  if (key == "root" && value instanceof Element) {
    return domToObj(value);
  }

  return value;
}

function createIntersectionObserver(options) {
  return new IntersectionObserver(function (entries, observer) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var entry = _step.value;
        var el = entry.target;
        var data = watchedElements.get(el);

        if (!data) {
          observer.unobserve(el);
          continue;
        }

        var intersecting = entry.isIntersecting;

        if (intersecting !== data.last) {
          data.fn(intersecting);
          data.last = intersecting;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }, options);
}

function getWatcher(fn, options) {
  // A replacer function is requred for the case when the 'root' option is provided
  // The root is an HTML element which will cause a circular reference error when stringified
  var key = JSON.stringify(options, replacer);
  var watcher = watchers.get(key);

  if (watcher) {
    return watcher;
  }

  var intersectionObserver = createIntersectionObserver(options);
  watchers.set(key, intersectionObserver);
  return intersectionObserver;
}

export function addVisibilityWatcher(el, fn) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    rootMargin: "0px 0px 250px 0px"
  };
  var watcher = getWatcher(fn, options);
  watchedElements.set(el, {
    fn: fn,
    last: null
  });
  watcher.observe(el);
  return function () {
    watcher.unobserve(el);
    watchedElements.delete(el);
  };
}
export function clearWatchers() {
  watchers.clear();
  watchedElements = new WeakMap();
}